const parseUrlSearch = (search: string): { [key: string]: string } => {
  const parts = search.substr(1).split('&');
  return parts.reduce((prev, val) => {
    const [key, value] = val.split('=');
    return { ...prev, [key]: value };
  }, {});
};

export { parseUrlSearch };
